export type Pakket = {
  title: string;
  perks: string[];
  price: string;
  note?: string;
};

export const pakketten: Pakket[] = [
  {
    title: "A1",
    perks: [
      "10 Rijlessen €68 per uur (60 minuten)",
      "Proefexamen",
      "Praktijk examen",
    ],
    price: "1030",
    note:
      "Uitsluitend voor mensen die wisselen van rijschool of herexamen doen. Het herexamen is gratis mits 8 lessen worden afgenomen.",
  },
  {
    title: "A2",
    perks: [
      "20 Rijlessen €66 per uur (60 minuten)",
      "Praktijk examen",
      "BESPAAR €40",
    ],
    price: "1670",
  },
  {
    title: "A3",
    perks: [
      "30 Rijlessen €64 per uur (60 minuten)",
      "Praktijk examen",
      "BESPAAR €60",
    ],
    price: "2270",
  },
  {
    title: "A4",
    perks: [
      "40 Rijlessen €62 per uur (60 minuten)",
      "Praktijk examen",
      "BESPAAR €80",
    ],
    price: "2830",
  },
  {
    title: "Faalangst pakket",
    perks: [
      "50 Rijlessen €60 per uur (60 minuten)",
      "Praktijkexamen faalangst",
      "Individueel theorie-examen",
      "Theorie boeken en leermateriaal",
      "Speciale begeleiding door een gecertificeerde faalangst instructeur",
    ],
    price: "4310",
  },
];

export type OverigPakket = {
  title: string;
  price: string;
};

export const overigePakketten: OverigPakket[] = [
  {
    title: "Losse les schakelauto (zonder pakket)",
    price: "68",
  },
  {
    title: "Losse les automaat (zonder pakket)",
    price: "68",
  },
  {
    title: "Praktijkexamen",
    price: "350",
  },
  {
    title: "Tussentijdse toets",
    price: "320",
  },
  {
    title: "Faalangst examen",
    price: "450",
  },
  {
    title: "Rijvaardigheidsonderzoek examen B-NO",
    price: "430",
  },
];
